import { RECEIVE_AUTONOMOUS_REGIONS, REQUEST_AUTONOMOUS_REGIONS } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_AUTONOMOUS_REGIONS:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_AUTONOMOUS_REGIONS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
